/**
 * Iter 20.24 — Shared internal delimiter for ClarifyingQuestion's optional
 * FreeTextAppendix. The value stored in the parent's `answers[i]` is a
 * single string, but combines chip-selection + optional note via this
 * delimiter. The delimiter is stripped by the QA-builder before sending
 * to the LLM.
 *
 * Uses U+2016 (DOUBLE VERTICAL LINE), an extremely rare character that
 * never appears in natural German text. If the LLM ever emitted it in a
 * label, we'd split incorrectly — but the risk is essentially zero.
 */
export const NOTE_DELIM = " \u2016 ";

export function splitAnswerValue(v) {
  const s = (v || "").toString();
  const idx = s.indexOf(NOTE_DELIM);
  if (idx === -1) return { main: s, note: "" };
  return { main: s.slice(0, idx), note: s.slice(idx + NOTE_DELIM.length) };
}

export function joinAnswerValue(main, note) {
  // Iter 20.35 — Bugfix: Vorher wurden `main`/`note` mittels `.trim()`
  // bereinigt, bevor sie zusammengefügt wurden. Bei React-controlled
  // Textareas hat das jedes trailing Space beim Tippen sofort entfernt,
  // sodass Leerschritte im Freitext-Ergänzungsfeld gar nicht persistiert
  // werden konnten (User-Bug: „Nein aber er hat" wurde zu „Neinabererhat").
  // Fix: Whitespace darf im User-Text erhalten bleiben. Wir prüfen nur
  // via `.trim()`, ob der jeweilige Wert überhaupt Inhalt hat, um zu
  // entscheiden, ob der Trenner gesetzt wird — die ORIGINAL-Werte werden
  // dabei unverändert konkateniert.
  const m = main || "";
  const n = note || "";
  const mHasContent = m.trim().length > 0;
  const nHasContent = n.trim().length > 0;
  if (!mHasContent && !nHasContent) return "";
  if (!nHasContent) return m;
  if (!mHasContent) return NOTE_DELIM + n; // leading delimiter marks note-only state
  return m + NOTE_DELIM + n;
}
